import React, { useCallback, useRef, useState } from "react";
import classNames from "classnames";
import "./WidgetInput.scss";

export interface IWidgetInput {
    classname: string;
    label?: string;
    value: string;
    onChange: (e) => void;
    placeholder?: string;
    readOnly?: boolean;
    defaultSelected?: boolean;
    isPasswordField?: boolean;
    maxLength?: number;
}

export const WidgetInput = ({
    classname,
    label,
    value,
    onChange,
    placeholder,
    readOnly,
    defaultSelected,
    isPasswordField,
    maxLength
}: IWidgetInput): JSX.Element => {
    const inputRef = useRef<HTMLInputElement>();

    const [visible, setVisible] = useState<boolean>(!isPasswordField);

    if (defaultSelected) {
        setTimeout(() => {
            // inputRef.current.selectionStart = 0;
            inputRef.current.focus();
            inputRef.current.select();
        }, 0);
    }

    const onToggle = useCallback(() => setVisible(!visible), [visible]);

    const onChangeValue = (val) => {
        if (val.target.value.length > maxLength) {
            inputRef.current.classList.add("invalid");
            return;
        }
        inputRef.current.classList.remove("invalid");
        onChange(val);
    };

    return (
        <form className={classNames("widget-input", classname, { "length-param": maxLength })}>
            {label ? <label>{label} </label> : null}
            <input
                ref={inputRef}
                type={visible ? "text" : "password"}
                value={value}
                placeholder={placeholder}
                onChange={onChangeValue}
                readOnly={readOnly}
            />
            {maxLength ? <span className="maxlength">{maxLength - value.length}</span> : null}
            {isPasswordField ? (
                <div className="password-eye" onClick={onToggle}>
                    <span className={visible ? "icon-geolite-hidden" : "icon-geolite-view"}></span>
                </div>
            ) : null}
        </form>
    );
};
